import { JSONSchemaType } from "ajv";
import validationPatters from "schema/patterns";

export interface ISignUpMultipleFormData {
  token: string;
  organizationId: string;
  email: string;
  password: string;
  userId?: string;
}

const SignUpMultipleSchema: JSONSchemaType<ISignUpMultipleFormData> = {
  type: "object",
  properties: {
    token: {
      type: "string",
    },
    organizationId: {
      type: "string",
    },
    userId: {
      type: "string",
      nullable: true,
    },
    email: {
      type: "string",
      pattern: validationPatters.email,
      minLength: 1,
      errorMessage: "Email é Inválido.",
    },
    password: {
      type: "string",
      minLength: 8,
      pattern: validationPatters.password,
      errorMessage: "Senha Inválida.",
    },
  },
  required: ["email", "password"],
  additionalProperties: false,
};

export default SignUpMultipleSchema;
